import { render, staticRenderFns } from "./BaseTableNoDataNoLocalized.vue?vue&type=template&id=472bc528"
import script from "./BaseTableNoDataNoLocalized.vue?vue&type=script&lang=js"
export * from "./BaseTableNoDataNoLocalized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports